import { render, staticRenderFns } from "./ActivationTab.vue?vue&type=template&id=04a51684&scoped=true"
import script from "./ActivationTab.vue?vue&type=script&lang=js"
export * from "./ActivationTab.vue?vue&type=script&lang=js"
import style0 from "./ActivationTab.vue?vue&type=style&index=0&id=04a51684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a51684",
  null
  
)

export default component.exports